/* eslint-disable max-classes-per-file */
import React from "react";
import {DndProvider, DragSource, DropTarget} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import PropTypes from "prop-types";
import DragSvg from "../../asset/icon/Drag.svg";

class Container extends React.Component {
    render() {
        const {children} = this.props;
        return (
            <DndProvider backend={HTML5Backend}>
                {children}
            </DndProvider>
        );
    }
}

const dragSpec = {
    beginDrag(props) {
        return {
            index: props.index,
        };
    },
};

const dropSpec = {
    hover(props, monitor) {
        const {index: dragIndex} = monitor.getItem();
        const {index: overIndex} = props;

        if (dragIndex !== overIndex) {
            props.move(dragIndex, overIndex);
            monitor.getItem().index = overIndex;
        }
    },
};

@DragSource("card", dragSpec, (conn, monitor) => ({
    connectDragSource: conn.dragSource(),
    connectDragPreview: conn.dragPreview(),
}))
@DropTarget("card", dropSpec, (conn, monitor) => ({
    connectDropTarget: conn.dropTarget(),
}))
class Item extends React.Component {
    static propTypes = {
        index: PropTypes.number.isRequired,
        move: PropTypes.func.isRequired,
    };

    render() {
        const {
            index, move, children, moveIndicatorStyle,
            connectDragSource, connectDragPreview, connectDropTarget,
            ...restProps
        } = this.props;

        return connectDropTarget(
            connectDragPreview(
                <div {...restProps}>
                    {connectDragSource(
                        <div style={{display: "flex", cursor: "move", ...moveIndicatorStyle}}>
                            <DragSvg style={{fontSize: 16, color: "#90A4AD"}} />
                        </div>,
                    )}
                    {children}
                </div>,
            ),
        );
    }
}

export default {
    Container,
    Item,
};
